<template>
  <div>
    <component
      :is="showH5Style ? 'el-drawer' : 'el-dialog'"
      title=""
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :custom-class="showH5Style ? 'h5-notes-dialog' : 'notes-dialog'"
      :direction="showH5Style ? 'btt' : ''"
      :close-on-click-modal="false"
      :wrapper-closable="false"
    >
      <div class="header-wrap">
        <p class="title">添加备注</p>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="dialog-cont-wrap">
        <!-- @focus="handleFocus" -->
        <el-input
          ref="myInput"
          class="notes-input"
          type="textarea"
          placeholder="请填写您的要求"
          v-model.trim="text"
          maxlength="50"
          show-word-limit
          resize="none"
        >
        </el-input>
        <div class="operate-wrap">
          <button @click="handleClose" v-preventReClick class="cancel-btn">
            取消
          </button>
          <button v-preventReClick class="submit-btn" @click="handleSubmit">
            确认
          </button>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import { isH5, isMGAppInPad } from "@saas/components/src";
export default {
  data() {
    return {
      dialogVisible: false,
      isH5: isH5(),
      text: "",
      isMGAppInPad: isMGAppInPad(),
      showH5Style: false,
    };
  },
  created() {
    this.showH5Style = this.isH5 && !this.isMGAppInPad;
  },
  methods: {
    // handleFocus() {
    //   setTimeout(() => {
    //     this.$refs?.myInput?.$el?.scrollIntoView(false);
    //   }, 300);
    // },
    handleClose(done) {
      this.$refs?.myInput?.blur();
      this.dialogVisible = false;
    },
    openDialog(text) {
      this.text = text;
      this.dialogVisible = true;
    },
    handleSubmit() {
      this.$emit("submit", this.text);
      this.handleClose();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .notes-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
  width: 375px;
  border-radius: 12px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    height: 282px;
    padding: 0;
  }
  .header-wrap {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    border-bottom: 1px solid #efefef;
    padding: 0 12px;
    font-weight: 500;
    font-size: 15px;
    color: #0d1400;
    line-height: 21px;
    i {
      position: absolute;
      top: 15px;
      right: 15px;
      font-size: 16px;
      font-weight: 500;
      color: #4e5969;
      cursor: pointer;
    }
  }
  .dialog-cont-wrap {
    padding: 12px 12px 0;
  }
  .notes-input {
    .el-textarea__inner {
      height: 131px;
      background: #f7f8f9;
      border-radius: 12px;
      border: none;
      font-size: 15px;
      color: #0d1400;
      &::placeholder {
        font-size: 15px;
        color: #747573;
      }
    }
    .el-input__count {
      background: #f7f8f9;
      font-size: 15px;
      color: #747573;
    }
  }
  .operate-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
  }
  .cancel-btn,
  .submit-btn {
    width: 165px;
    height: 50px;
    border-radius: 12px;
    font-weight: 500;
    font-size: 16px;
    color: #0d1400;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f2f3f5;
  }
  .submit-btn {
    color: #ffffff;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
  }
}
::v-deep .h5-notes-dialog {
  height: 7.51rem !important;
  #el-drawer__title {
    display: none;
  }
  .header-wrap {
    position: relative;
    height: 1.17rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 0.4rem;
    color: #0d1400;
    line-height: 0.56rem;
    border-bottom: 0.03rem solid #efefef;
    i {
      position: absolute;
      top: 0.4rem;
      right: 0.4rem;
      font-size: 0.4rem;
      color: #4e5969;
    }
  }
  .dialog-cont-wrap {
    padding: 0.32rem 0.32rem 0;
  }
  .notes-input {
    .el-textarea__inner {
      height: 3.48rem;
      background: #f7f8f9;
      border-radius: 0.32rem;
      border: none;
      font-size: 0.4rem;
      color: #0d1400;
      &::placeholder {
        font-size: 0.4rem;
        color: #747573;
      }
    }
    .el-input__count {
      background: #f7f8f9;
      font-size: 0.4rem;
      color: #747573;
    }
  }
  .operate-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 0.67rem;
  }
  .cancel-btn,
  .submit-btn {
    width: 4.4rem;
    height: 1.33rem;
    border-radius: 0.32rem;
    font-weight: 500;
    font-size: 0.43rem;
    color: #0d1400;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f2f3f5;
  }
  .submit-btn {
    color: #ffffff;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
  }
}
</style>
